import { createAction, props } from '@ngrx/store';

export const loadPrinter = createAction(
  '[Printer] Load Printer'
);

export const loadPrinterSuccess = createAction(
  '[Printer] Load Printer Success',
  props<{ printer: any }>()
);

export const loadPrinterFailure = createAction(
  '[Printer] Load Printer Failure',
  props<{ error: any }>()
);

export const connectPrinter = createAction(
  '[Printer] Connect Printer',
  props<{ printer: any }>()
);

export const connectPrinterSuccess = createAction(
  '[Printer] Connect Printer Success',
  props<{ printer: any }>()
);

export const connectPrinterFailure = createAction(
  '[Printer] Connect Printer Failure',
  props<{ error: any }>()
);

export const ignorePrinter = createAction(
  '[Printer] Ignore Printer'
);

export const resetPrinterIgnore = createAction(
  '[Printer] Reset Printer Ignore'
);
